import React from 'react'
import PropTypes from 'prop-types'

import useTrackingContext from '../hooks/useTrackingContext'
import useScrolledToElement from '../hooks/useScrolledToElement'

const ErrorPage = ({ error }) => {
  const tracker = useTrackingContext()
  const scrolledToElement = useScrolledToElement()

  if (tracker) {
    tracker.trackException(error.message)
  }

  return (
    <div ref={scrolledToElement}>
      <h1>Es ist ein Fehler aufgetreten</h1>

      <p data-testid='error-page'>
      Die Fehlermeldung war:<br />
        <code className='text text-danger'>{error?.message}</code>
      </p>
      <p>Versuche es evtl. noch einmal!</p>
      <button type='button' onClick={() => window.location.reload()} className='btn btn-primary'>
        Neu laden
      </button>
    </div>
  )
}

ErrorPage.propTypes = {
  error: PropTypes.object.isRequired,
}

export default ErrorPage
